
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "83px",
    "height": "86px",
    "viewBox": "-0.32 -0.28 83 86",
    "enable-background": "new -0.32 -0.28 83 86",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "linearGradient",
      "attrsMap": {
        "id": "SVGID_4_",
        "gradientUnits": "userSpaceOnUse",
        "x1": "65.2285",
        "y1": "86.5635",
        "x2": "1.1162",
        "y2": "4.5034"
      },
      "children": [
        {
          "tag": "stop",
          "attrsMap": {
            "offset": "0",
            "style": "stop-color:#0068B7"
          }
        },
        {
          "tag": "stop",
          "attrsMap": {
            "offset": "1",
            "style": "stop-color:#00A0E9"
          }
        }
      ]
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "url(#SVGID_4_)",
        "points": "8.918,77.952 8.918,1.063 44.167,1.063 \r\n\t67.893,26.511 67.893,77.952 "
      }
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#EFEFEF",
        "points": "17.326,85.301 17.326,8.467 54.294,8.467 79.178,33.896 \r\n\t79.178,85.301 "
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "defs",
          "children": [
            {
              "tag": "polygon",
              "attrsMap": {
                "id": "SVGID_3_",
                "points": "17.326,85.301 17.326,8.467 54.294,8.467 79.178,33.896 79.178,85.301 \t\t"
              }
            }
          ]
        },
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "SVGID_5_"
          },
          "children": [
            {
              "tag": "use",
              "attrsMap": {
                "xlink:href": "#SVGID_3_",
                "overflow": "visible"
              }
            }
          ]
        },
        {
          "tag": "g",
          "attrsMap": {
            "clip-path": "url(#SVGID_5_)"
          },
          "children": [
            {
              "tag": "linearGradient",
              "attrsMap": {
                "id": "SVGID_6_",
                "gradientUnits": "userSpaceOnUse",
                "x1": "81.0137",
                "y1": "-0.3691",
                "x2": "61.2843",
                "y2": "23.9946"
              },
              "children": [
                {
                  "tag": "stop",
                  "attrsMap": {
                    "offset": "0",
                    "style": "stop-color:#B5B5B6"
                  }
                },
                {
                  "tag": "stop",
                  "attrsMap": {
                    "offset": "1",
                    "style": "stop-color:#FFFFFF"
                  }
                }
              ]
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "url(#SVGID_6_)",
                "stroke": "#898989",
                "stroke-width": "0.5669",
                "stroke-miterlimit": "22.9256",
                "d": "\r\n\t\t\tM54.149,31.223c0-5.151,0-10.309,0-15.463s0-10.315,0-15.477c4.607,0,9.213,0,13.814,0c4.602,0,9.205,0,13.804,0\r\n\t\t\tc0,5.161,0,10.322,0,15.477s0,10.312,0,15.463c-4.599,0-9.202,0-13.804,0C63.362,31.223,58.756,31.223,54.149,31.223z"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "x": "20.898",
                "y": "22.288",
                "opacity": "0.5",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "#729A98",
                "width": "27.456",
                "height": "2.112"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "x": "20.898",
                "y": "31.016",
                "opacity": "0.5",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "#729A98",
                "width": "27.457",
                "height": "2.113"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "x": "20.898",
                "y": "39.744",
                "opacity": "0.5",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "#729A98",
                "width": "54.914",
                "height": "2.113"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "x": "20.898",
                "y": "48.473",
                "opacity": "0.5",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "#729A98",
                "width": "54.914",
                "height": "2.112"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "x": "20.898",
                "y": "57.2",
                "opacity": "0.5",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "#729A98",
                "width": "54.914",
                "height": "2.112"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "x": "20.898",
                "y": "65.928",
                "opacity": "0.5",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "#729A98",
                "width": "54.914",
                "height": "2.113"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "x": "20.898",
                "y": "74.655",
                "opacity": "0.5",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                "fill": "#729A98",
                "width": "54.914",
                "height": "2.113"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "none",
        "stroke": "#898989",
        "stroke-width": "0.5669",
        "stroke-miterlimit": "22.9256",
        "points": "\r\n\t17.326,85.301 17.326,8.467 54.294,8.467 79.178,33.896 79.178,85.301 "
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "5.513",
        "y": "19.784",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFFFFF",
        "width": "25.196",
        "height": "25.195"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "defs",
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "SVGID_1_",
                "y": "14.273",
                "width": "36.22",
                "height": "36.219"
              }
            }
          ]
        },
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "SVGID_7_"
          },
          "children": [
            {
              "tag": "use",
              "attrsMap": {
                "xlink:href": "#SVGID_1_",
                "overflow": "visible"
              }
            }
          ]
        },
        {
          "tag": "g",
          "attrsMap": {
            "transform": "matrix(1 0 0 1 0 -9.323937e-007)",
            "clip-path": "url(#SVGID_7_)"
          },
          "children": [
            {
              "tag": "image",
              "attrsMap": {
                "overflow": "visible",
                "width": "172",
                "height": "172",
                "xlink:href": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBVgFWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA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\ngtJ2C0nYLSdgtJ2C0nYIOewtEDtIX//Z",
                "transform": "matrix(0.2106 0 0 0.2106 0 14.2725)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#3F6D56",
        "d": "M33.858,48.13V16.634H2.362V48.13H33.858L33.858,48.13L33.858,48.13z M30.709,19.783v25.196H5.512V19.783\r\n\tH30.709L30.709,19.783z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#3F6D56",
        "d": "M27.953,26.477v-1.969h-7.088l-3.148,3.15l-3.15-3.15H7.087v1.969l5.905,5.905l-6.693,6.693v1.969h14.73\r\n\tv0.787h8.499v-2.443l-2.756-2.674l1.345-1.576v-1.967h-6.463L27.953,26.477L27.953,26.477L27.953,26.477z M8.662,25.689h1.18\r\n\tl14.174,14.173v0.787h-1.182L8.662,26.477V25.689L8.662,25.689z"
      }
    }
  ]
})
    }
  